import { useState } from "react";

import { AnimatePresence, motion } from "framer-motion";
import PropTypes from "prop-types";

import TabButton from "@/components/actions/button/tabBtn";
import {
  AccordionMinusIcon,
  AccordionPlusIcon,
} from "@/components/data-display/icon";

function ItemDetailsAccordion({ title, children, isAccordionOpen }) {
  const [isOpen, setIsOpen] = useState(isAccordionOpen);

  return (
    <article>
      <TabButton
        className="pl-4 pr-2"
        onClick={() => setIsOpen(!isOpen)}
        isActive={isOpen}
      >
        <div className="flex w-full items-center justify-between">
          <p className="text-[0.938rem] font-medium sm:text-[1rem]">{title}</p>
          {!isOpen && (
            <AccordionPlusIcon className="h-[2.625rem] w-[2.5rem] text-primary" />
          )}
          {isOpen && (
            <AccordionMinusIcon className="h-[2.625rem] w-[2.5rem] text-white" />
          )}
        </div>
      </TabButton>
      <AnimatePresence>
        {isOpen && (
          <div className="">
            <motion.div
              variants={{
                open: {
                  height: "auto",
                  marginTop: 28,
                },
                closed: {
                  height: 0,
                  marginTop: 0,
                },
              }}
              initial="closed"
              animate="open"
              exit="closed"
              transition={{ delay: 0.1, duration: 0.4 }}
              className="overflow-hidden"
            >
              {children}
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </article>
  );
}

ItemDetailsAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  isAccordionOpen: PropTypes.bool,
};

export default ItemDetailsAccordion;
